/* Premier Catering Supplies homepage — tab switching for the "Popular now" rails. No network calls. */
(function () {
  'use strict';
  var roots = document.querySelectorAll('[data-pch-tabs]');
  roots.forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pch-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pch-panel]'));
    if (!tabs.length) return;
    function activate(id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-pch-tab') === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) t.focus();
        if (on && t.scrollIntoView) { try { t.scrollIntoView({ block: 'nearest', inline: 'center' }); } catch (err) {} }
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-pch-panel') === id;
        p.classList.toggle('is-active', on);
        if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });
    }
    tabs.forEach(function (t, i) {
      t.setAttribute('tabindex', t.classList.contains('is-active') ? '0' : '-1');
      t.addEventListener('click', function () { activate(t.getAttribute('data-pch-tab'), false); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); activate(n.getAttribute('data-pch-tab'), true); }
      });
    });
    /* fade hint on the right of the tab strip while more tabs are off-screen */
    var wrap = root.querySelector('[data-pch-tabs-wrap]');
    var list = root.querySelector('[data-pch-tablist]');
    if (wrap && list) {
      var hint = function () {
        var more = list.scrollWidth - list.clientWidth - list.scrollLeft > 4;
        wrap.classList.toggle('has-more', more);
        wrap.classList.toggle('has-prev', list.scrollLeft > 4);
      };
      list.addEventListener('scroll', hint, { passive: true });
      window.addEventListener('resize', hint);
      hint();
    }
  });

  /* Shop-by-business cards: accordion on phones, always open on wider screens */
  var biz = Array.prototype.slice.call(document.querySelectorAll('[data-pch-biz]'));
  if (biz.length) {
    var mq = window.matchMedia('(max-width: 749px)');
    var touched = false, applying = false;
    var applyBiz = function () {
      applying = true;
      if (mq.matches) {
        if (!touched) biz.forEach(function (d, i) { d.open = i === 0; });
      } else {
        biz.forEach(function (d) { d.open = true; });
      }
      setTimeout(function () { applying = false; }, 0);
    };
    biz.forEach(function (d) { d.addEventListener('toggle', function () { if (mq.matches && !applying) touched = true; }); });
    applyBiz();
    if (mq.addEventListener) mq.addEventListener('change', function () { touched = false; applyBiz(); });
  }
})();